export default __webpack_public_path__ + "static/media/attention.f9494678.svg";